import {CustomerSortEnum} from "../enums/customer-sort.enum";
import {SortMenuGroup} from "../types/customer-sort-menu.type";

export const customerSortOptionGroups: SortMenuGroup[] = [
  {
    title: "مشتریان",
    options: [
      {
        value: CustomerSortEnum.HighestInvoiceCount,
        key: "بیشترین تعداد فاکتور",
      },
      {
        value: CustomerSortEnum.LowestInvoiceCount,
        key: "کمترین تعداد فاکتور",
      },
      {
        value: CustomerSortEnum.HighestPurchaseAmount,
        key: "بیشترین مبلغ خرید",
      },
      {
        value: CustomerSortEnum.LowestPurchaseAmount,
        key: "کمترین مبلغ خرید",
      },
      {
        value: CustomerSortEnum.HighestAverageInvoiceAmount,
        key: "بیشترین میانگین مبلغ فاکتور",
      },
      {
        value: CustomerSortEnum.LowestAverageInvoiceAmount,
        key: "کمترین میانگین مبلغ فاکتور",
      },
    ],
  },
  {
    options: [
      {
        value: CustomerSortEnum.CustomersWithoutPurchase,
        key: "مشتریان بدون خرید",
      },
      {value: CustomerSortEnum.NewCustomers, key: "مشتریان جدید"},
      {value: CustomerSortEnum.LoyalCustomers, key: "مشتریان وفادار"},
    ],
  },
];
